import {createRouter, createWebHistory} from "vue-router";
import Login from "@/components/layouts/auth/Login.vue";
import SignUp from "@/components/layouts/auth/SignUp.vue";
import Dashboard from "@/components/layouts/views/Dashboard.vue";
import Profile from "@/components/layouts/views/Profile.vue";
import MenuCreate from "@/components/layouts/views/MenuCreate.vue";
import Message from "@/components/layouts/views/Data/Message.vue";
import PageNotFound from "@/components/layouts/views/page-not-found/PageNotFound";
import CreateWasiyyah from "@/components/layouts/views/Data/CreateWasiyyah.vue";
import Calculation from "@/components/layouts/views/Data/Calculation.vue";
import WasiyyahPreview from "@/components/layouts/views/Data/WasiyyahPreview.vue";
import Witness from "@/components/layouts/views/Data/Witness.vue";
import CreateWitness from "@/components/layouts/views/Data/CreateWitness.vue";
import OutsideWitness from "@/components/layouts/views/Data/OutsideWitness.vue";
import CalculationZakat from "@/components/layouts/views/Data/CalculationZakat.vue";
import WitnessDetails from "@/components/layouts/views/Data/WitnessDetails.vue";
import PasswordChange from "@/components/layouts/auth/PasswordChange.vue";
import { jwtDecode } from "jwt-decode";
import Submenu from "@/components/layouts/views/Submenu/Submenu";
import NisabaSave from "@/components/layouts/views/Admin/NisabaSave";
import BlogPost from "@/components/layouts/views/Admin/BlogPost";
import BranchAdd from "@/components/layouts/views/Admin/BranchAdd";
import IPAllowed from "@/components/layouts/views/Admin/IPAllowed";
import NomineePanel from "@/components/layouts/views/User/NomineePanel";
import Nominee from "@/components/layouts/views/Data/Nominee";
import CreateNominee from "@/components/layouts/views/Data/CreateNominee";
import OutsideNominee from "@/components/layouts/views/Data/OutsideNominee";

const isAuthenticated = () => {
    const token = localStorage.getItem("authToken"); // Replace with your token key
    if (!token) {
        return false; // No token found
    }

    try {
        const decoded = jwtDecode(token); // Decode the token
        const currentTimestamp = Math.floor(Date.now() / 1000); // Current time in seconds
        if (decoded.exp && decoded.exp > currentTimestamp) {
            return true; // Token is valid and not expired
        }
        return false; // Token is expired
    } catch (error) {
        console.error("Invalid token:", error);
        return false; // Invalid token format
    }
};
// Define routes
const routes = [
    {
        path: "/login",
        component: Login,
        name: "Login",
        meta: {requiresAuth: false},
    },
    {
        path: "/sign-up",
        component: SignUp,
        name: "SignUp",
        meta: {requiresAuth: false},
    },
    {
        path: "/admin",
        name: "AdminHome",
        meta: {requiresAuth: true},
        children: [
            {path: "dashboard", component: Dashboard, name: "Dashboard"},
            {path: "profile", component: Profile, name: "Profile"},
            {path: "menu", component: MenuCreate, name: "menu-create"},
            {path: "sub-menu-create", component: Submenu, name: "sub-menu-create"},
            {path: "calc", component: Calculation, name: "calc"},
            {path: "all-messages", component: Message, name: "all-messages"},
            {path: "wasiyyah-preview", component: WasiyyahPreview, name: "wasiyyah-preview"},
            {path: "create-wasiyyah", component: CreateWasiyyah, name: "create-wasiyyah"},
            {path: "witness", component: Witness, name: "witness"},
            {path: "nominee", component: Nominee, name: "nomineeShow"},
            {path: "witness-details", component: WitnessDetails, name: "witness-details"},
            {path: "search-witness", component: CreateWitness, name: "create-witness"},
            {path: "search-nominee", component: CreateNominee, name: "createNominee"},
            {path: "outside-witness", component: OutsideWitness, name: "outside-witness"},
            {path: "outside-nominee", component: OutsideNominee, name: "outside-nominee"},
            {path: "calc-zakat", component: CalculationZakat, name: "calc-zakat"},
            {path: "password-change", component: PasswordChange, name: "password-change"},
            {path: "nisab-insert", component: NisabaSave, name: "admin-nisab-insert"},
            {path: "blog-post", component: BlogPost, name: "blog-post"},
            {path: "branch-add", component: BranchAdd, name: "branch-add"},
            {path: "ip-allowed", component: IPAllowed, name: "ip-allowed"},
            {path: "nominee-panel/:id", component: NomineePanel, name: "nominee-panel"},
            {path: "witness-panel/:id", component: NomineePanel, name: "witness-panel"},

        ],
    },
    {path: "/:pathMatch(.*)*", component: PageNotFound, name: "PageNotFound"},
];

// Create router instance
const router = createRouter({
    history: createWebHistory(),
    routes,
});

// Navigation guard
router.beforeEach((to, from, next) => {
    const loggedIn = isAuthenticated();
    if (to.meta.requiresAuth && !loggedIn) {
        next({ name: "Login" }); // Redirect root path to login if not authenticated
    } else if ((to.path === "/" || to.path === "/sign-up") && loggedIn) {
        next({ name: "Dashboard" });
    } else if ((to.path === "/login" || to.path === "/sign-up") && loggedIn) {
        // Redirect login route to dashboard if authenticated
        next({ name: "Dashboard" });
    } else if (!loggedIn && to.path !== "/login" && to.path !== "/sign-up") {
        // Redirect to login if not authenticated and trying to access any route other than login or sign-up
        next({ name: "Login" });
    } else {
        next(); // Proceed to the requested route
    }
});

export default router;